import { render, staticRenderFns } from "./ApplicationsListModalPurchases.vue?vue&type=template&id=4fd0903b&"
import script from "./ApplicationsListModalPurchases.vue?vue&type=script&lang=js&"
export * from "./ApplicationsListModalPurchases.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsListModalPurchases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VDivider,VIcon,VList})
